import { Controller } from "@hotwired/stimulus"

// Dodo billing fields on the paywall: keeps the prefilled capital-city zip
// in sync with the selected country. The map comes from
// Courses::PaymentsHelper::DODO_CAPITAL_POSTCODES via a data attribute.
export default class extends Controller {
  static targets = ["zip"]
  static values = { postcodes: Object }

  connect() {
    // Remember the server-prefilled zip so countryChanged only ever replaces
    // values we filled in ourselves — never something the user typed.
    this.lastAutofill = this.hasZipTarget ? this.zipTarget.value : ""
  }

  // Swap the prefilled capital-city zip when the country changes; unmapped
  // countries clear the field so the user types their own.
  countryChanged(event) {
    if (!this.hasZipTarget) return
    const zip = this.zipTarget
    if (zip.value && zip.value !== this.lastAutofill) return

    const code = this.postcodesValue[event.target.value] || ""
    zip.value = code
    this.lastAutofill = code
  }
}
